import { DtoBasket } from '@epicuro-next/data/baskets-dto';
import { isNullish } from '@epicuro-next/utilities';

export function isDtoBackendUnavailable(basket: DtoBasket) {
  return basket.items.some((item) => isNullish(item.confirmedQuantity));
}
